<template>
  <div class="use-container">
    <div id="storageChart" style="height: 100%; width: 98%"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import API from "../api/index";
export default {
  data() {
    return {
      storageChart: null,
      storageChartOption: {},
      coldData: {}
    };
  },
  mounted() {
    var self = this;
    self.storageChart = echarts.init(document.getElementById("storageChart"));
    self.queryData().then((res) => {
      self.initStorageUseChart(res)
    });
  },
  methods: {
    queryData() {
      return new Promise((resolve, reject) => {
        this.$fetch(API.statColdStorageUse).then((res) => {
          if (res.success) {
            this.coldData = res.returnObj.slice(0, 3);
            resolve(this.coldData);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    initStorageUseChart() {
      let that = this
      this.storageChartOption = {
        tooltip: {
          trigger: "axis",
          show: true,
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          show: false,
        },
        grid: {
          left: "5%",
          right: "20%",
          bottom: "0%",
          top: "5%",
          containLabel: true,
        },
        xAxis: [
          {
            splitLine: {
              show: false,
            },
            type: "value",
            show: false,
          },
        ],
        yAxis: [
          {
            splitLine: {
              show: false,
            },
            axisLine: {
              // y轴
              show: false,
            },
            type: "category",
            axisTick: {
              show: false,
            },
            inverse: true,
            data: this.coldData.map((el) => {
              return el.coldStorageName;
            }),
            axisLabel: {
              color: "#ffffff",
              fontSize: 14,
              padding: [3, 0, 0, 0]
            },
          },
        ],
        series: [
          {
            name: "当前库存",
            zlevel: 2,
            type: "bar",
            barWidth: 15, // 柱子宽度
            label: {
              show: true,
              position: "inside", // 位置
              color: "#ffffff",
              fontSize: 12,
              distance: 15, // 距离
              formatter: function (params) {
                return that.coldData[params.dataIndex].usageProportion
              }, // 这里是数据展示的时候显示的数据
            }, // 柱子上方的数值
            itemStyle: {
              barBorderRadius: [0, 20, 20, 0], // 圆角（左上、右上、右下、左下）
              color: new echarts.graphic.LinearGradient(0, 1, 1, 1, [
                { offset: 0, color: "#395CFE" },
                { offset: 1, color: "#2EC7CF" },
              ]),
            },
            data: this.coldData.map((el) => {
              return el.oftenCapacity;
            }),
          },
          {
            name: "库存容量",
            type: "bar",
            barWidth: 15, // 柱子宽度，
            barGap: "-100%",
            label: {
              show: true,
              position: "right", // 位置
              color: "#ffffff",
              fontSize: 14,
              distance: 15, // 距离
              formatter: "{c}", // 这里是数据展示的时候显示的数据
            }, // 柱子上方的数值
            itemStyle: {
              barBorderRadius: [0, 20, 20, 0], // 圆角（左上、右上、右下、左下）
              color: "rgba(3,169,244, 0.2)",
            },
            data: this.coldData.map((el) => {
              return el.inventoryCapacity;
            }),
          },
        ],
      };
      this.storageChart.setOption(this.storageChartOption);
    }
  }
};
</script>

<style lang='scss' scoped>
.use-container {
  height: 100%;
}
</style>